import { render, staticRenderFns } from "./cardFeaturedSponsorsSM.vue?vue&type=template&id=06f25d72&scoped=true"
import script from "./cardFeaturedSponsorsSM.vue?vue&type=script&lang=js"
export * from "./cardFeaturedSponsorsSM.vue?vue&type=script&lang=js"
import style0 from "./cardFeaturedSponsorsSM.vue?vue&type=style&index=0&id=06f25d72&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f25d72",
  null
  
)

export default component.exports